module.exports = __webpack_public_path__ + "img/1.3d97a2c1.gif";